import { render, staticRenderFns } from "./singleSpecs.vue?vue&type=template&id=4faade66&scoped=true"
import script from "./singleSpecs.vue?vue&type=script&lang=js"
export * from "./singleSpecs.vue?vue&type=script&lang=js"
import style0 from "./singleSpecs.vue?vue&type=style&index=0&id=4faade66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faade66",
  null
  
)

export default component.exports